import {useEffect, useState} from 'react';

const getIsMobileResolution = (): boolean => {
    // Mobile device break point: 768px
    return (window.innerWidth <= 768) as boolean;
}

export const useIsMobileResolution = () => {
    const [isMobileResolution, setIsMobileResolution] = useState<boolean>(getIsMobileResolution());
    const onResize = () => setIsMobileResolution(getIsMobileResolution());

    const handleResize = () => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        }
    };

    useEffect(() => {
        handleResize();
    }, []);

    return isMobileResolution;
};
